let BASE_URL, SECOND_URL;

const host = window.location.host;

export const isDev = host.includes('cab.codevision')

if (host.includes('localhost') || host === 'localhost') {
    BASE_URL = `http://app.localhost/api/v1/`;
} else if (host.includes('cab.codevision')) {
    BASE_URL = `http://cab.codevision.agency:8033/api/v1/`;
} else {
    BASE_URL = `${window.location.origin}/api/v1/`;
}
SECOND_URL = 'http://app.localhost/';

export const API_BASE_URL = BASE_URL;
export const API_SECOND_URL = SECOND_URL;
